import React from 'react';

import { Poi } from '../../../../../../viewer/elements/poi/poi';
import { useNonce } from '../../../../../hooks/use-nonce';
import { useAsset } from '../../../hooks/use-asset';
import { Asset } from '../../components/asset-blocks/asset';
import { PoiBody } from './poi-body';
import { PoiHeader } from './poi-header';

type Props = {
  asset: Poi;
};

const PoiAsset = (props: Props) => {
  const [nonce, refresh] = useNonce();
  useAsset(props.asset, {
    onAssetChanged: () => {
      refresh();
    },
  });

  React.useEffect(() => {
    props.asset.onMetaDataUpdated = refresh;

    return () => {
      props.asset.onMetaDataUpdated = undefined;
    };
  }, [props.asset, refresh]);

  return (
    <Asset asset={props.asset}>
      {{
        header: <PoiHeader asset={props.asset} refreshAsset={refresh} />,
        content: <PoiBody asset={props.asset} refreshAsset={refresh} refreshNonce={nonce} />,
      }}
    </Asset>
  );
};

export { PoiAsset, Props as PoiAssetProps };
